<app-add-contract [contextIdDto]="contextIdDto" [linkId]="linkId" [isContractModal]="isContractModal"
  (contractCreated)="contractEvent($event)"></app-add-contract>
